<div *ngIf="isLoading" class="ion-text-centerion-padding ion-margin">
  <ion-spinner icon="crescent" color="primary"></ion-spinner>
</div>

<div
  class="ion-text-center ion-margin ion-padding"
  *ngIf="errorOccured"
  (click)="loadCredentials()"
>
  <ion-note> Oops something went wrong. Pelase tap to retry. </ion-note>
</div>

<ng-container *ngIf="!isLoading && !errorOccured">
  <ion-row *ngIf="cashTip">
    <ion-col>
      <ion-button
        fill="outline"
        expand="block"
        color="primary"
        [disabled]="sale.lineitems.count() == 0 || sale.status == 1"
        (click)="addTip(0 - this.sale.balance)"
      >
        Add {{ 0 - this.sale.balance | salonMonsterCurrency }} Tip
      </ion-button>
    </ion-col>
    <ion-col>
      <ion-button
        expand="block"
        color="primary"
        [disabled]="sale.lineitems.count() == 0 || sale.status == 1"
        (click)="payCashWithouTip()"
      >
        Complete
      </ion-button>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="sale && sale.isRefundSale()">
    <ion-col>
      <ion-button expand="block" color="primary" (click)="selectRefundMethod()"> Continue </ion-button>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="!sale?.isRefundSale()&&!cashTip">
    <ion-col *ngIf="!isSquarePOSEnabled()">
      <ion-button
        fill="outline"
        expand="block"
        color="primary"
        [disabled]="sale.lineitems.count() == 0 || sale.status == 1"
        (click)="addTip(0)"
      >
        Add Tip
      </ion-button>
    </ion-col>
    <ion-col *ngIf="!isSquarePOSEnabled()">
      <ion-button
        *ngIf="!hasStripeAccount"
        expand="block"
        color="primary"
        [disabled]="sale.lineitems.count() == 0 || sale.status == 1"
        (click)="addPayment(false)"
      >
        {{ this.sale.isSaleReadyForCheckOut() ? "Complete" : "Add Payment" }}
      </ion-button>
      <ion-button
        *ngIf="hasStripeAccount"
        expand="block"
        [ngClass]="{
          chargeButtonWithDropDown: hasStripeAccount && hardwareIsConnected
        }"
        color="primary"
        [disabled]="sale.lineitems.count() == 0 || sale.status == 1"
        (click)="addPayment(false)"
      >
        Charge
      </ion-button>
      <ion-button
        *ngIf="hasStripeAccount && hardwareIsConnected"
        expand="block"
        color="primary"
        class="dropdownButton"
        [disabled]="sale.lineitems.count() == 0 || sale.status == 1"
        (click)="addPayment(true)"
      >
        <ion-icon name="chevron-down"></ion-icon>
      </ion-button>
    </ion-col>
    <ion-col *ngIf="isSquarePOSEnabled()">
      <ion-button
        expand="block"
        color="primary"
        [disabled]="sale.lineitems.count() == 0 || sale.status == 1"
        (click)="onSquareCheckOut()"
      >
        Square POS
      </ion-button>
    </ion-col>
  </ion-row>
</ng-container>
